import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-committee25',
  templateUrl: './program-committee.component.html',
  styleUrls: ['./program-committee.component.css']
})
export class ProgramCommitteeComponent25 implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
